import { writable } from 'svelte/store';
export const speakerState = writable([]);